import { useState } from 'react';
import { checkSn } from '@/service/service-renewal';
import type { SnCheckResult } from './types';

interface UseSnVerificationReturn {
    loading: boolean;
    result: SnCheckResult | null;
    error: string | null;
    verify: (params: { sn: string; campaignId: number; snUrl: string; deviceUrl: string }, locale: string) => Promise<SnCheckResult | null>;
    reset: () => void;
    resetError: () => void;
}

/**
 * SN 码校验 hook，调用 verify 发起请求，结果缓存在 result 中
 */
export const useSnVerification = (): UseSnVerificationReturn => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<SnCheckResult | null>(null);
    const [error, setError] = useState<string | null>(null);

    const verify = async (
        params: { sn: string; campaignId: number; snUrl: string; deviceUrl: string },
        locale: string,
    ): Promise<SnCheckResult | null> => {
        setLoading(true);
        setError(null);
        try {
            const res = await checkSn(params, locale);
            if (res?.code === '0') {
                setResult(res.data);
                return res.data;
            } else {
                setError(res?.message ?? 'SN verification failed');
                return null;
            }
        } catch (err: any) {
            setError(err?.message ?? 'SN verification failed');
            return null;
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setResult(null);
        setError(null);
    };

    const resetError = () => setError(null);

    return { loading, result, error, verify, reset, resetError };
};
